export const MS_IN_HOUR = 60 * 60 * 1000;